/**
 * @generated SignedSource<<b9a2ba344f73d6553b3ce3dddac5f96f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type actionButtonsTracking_item$data = {
  readonly browseUrl: string | null;
  readonly categoryCode: string | null;
  readonly contemporaryTrackingString: string;
  readonly isAuctionEnabled: boolean | null;
  readonly lastTransaction?: {
    readonly secondChanceOffer: {
      readonly amountPerItem: {
        readonly convertedAmounts: {
          readonly USD: number | null;
        } | null;
      } | null;
    } | null;
  } | null;
  readonly pricing: {
    readonly totalAmount: {
      readonly convertedAmounts: {
        readonly AUD: number | null;
        readonly CAD: number | null;
        readonly CHF: number | null;
        readonly DKK: number | null;
        readonly EUR: number | null;
        readonly GBP: number | null;
        readonly MXN: number | null;
        readonly NOK: number | null;
        readonly SEK: number | null;
        readonly USD: number | null;
      } | null;
    } | null;
  } | null;
  readonly relevantAuctionLot?: {
    readonly buyItNowPrice: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
  } | null;
  readonly relevantAuctionSolution?: {
    readonly bids: {
      readonly totalResults: number | null;
    } | null;
    readonly highestBidAmount: {
      readonly convertedAmounts: {
        readonly USD: number | null;
      } | null;
    } | null;
  } | null;
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "actionButtonsTracking_item";
};
export type actionButtonsTracking_item$key = {
  readonly " $data"?: actionButtonsTracking_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"actionButtonsTracking_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "actionButtonsTracking_item"
};

(node as any).hash = "04cf03b5b2391df7c0ca5cb6bacb9823";

export default node;
